if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 769px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if(activeThumbnail && activeThumbnail.dataset.mediaPosition){
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}





if (!Shopify.designMode) {
  if (window.matchMedia('(min-width: 769px)').matches) {
    document.querySelectorAll('.shopify-section.section:has([data-section-name])').forEach((html) => {
      const target = document.querySelector('.product-page-sections-left');
      const clone = html.cloneNode(true);
      target.appendChild(clone)
      html.remove()      
    })
  if(document.querySelector('#ReviewsWidget')) {
      new ReviewsWidget('#ReviewsWidget', {
        // Your REVIEWS.io Store ID and widget type
        store: 'theoneglove.com',
        widget: 'polaris',
    
        // Content settings (store_review, product_review, third_party_review, questions).
        // Choose what to display in this widget
        options: {
          types: 'product_review,questions',
          lang: 'en', // Language setting
          layout: '', // Possible layout options: bordered, large, and reverse
          per_page: 5,
    
          store_review: {
            hide_if_no_results: false,
          },
    
          third_party_review: {
            hide_if_no_results: false,
          },
    
          product_review: {
            sku: document.querySelector('#ReviewsWidget').dataset.sku,
            hide_if_no_results: false,
          },
    
          questions: {
            hide_if_no_results: false,
            enable_ask_question: true,
            show_dates: true,
            grouping: document.querySelector('#ReviewsWidget').dataset.sku,
          },
    
          // Header settings
          header: {
            enable_summary: true,
            enable_ratings: true,
            enable_attributes: true,
            enable_image_gallery: true,
            enable_percent_recommended: false,
            enable_write_review: true,
            enable_ask_question: true,
            enable_sub_header: true,
            rating_decimal_places: 2,
            use_write_review_button: false,
          },
    
          // Filtering settings
          filtering: {
            enable: false,
            enable_text_search: false,
            enable_sorting: true,
            enable_product_filter: false,
            enable_media_filter: true,
            enable_overall_rating_filter: false,
            enable_language_filter: false,
            enable_language_filter_language_change: false,
            enable_ratings_filters: false,
            enable_attributes_filters: false,
            enable_expanded_filters: false,
          },
    
          // Review settings
          reviews: {
            enable_avatar: true,
            enable_reviewer_name: true,
            enable_reviewer_address: false,
            reviewer_address_format: 'city, country',
            enable_verified_badge: true,
            enable_subscriber_badge: true,
            review_content_filter: 'undefined',
            enable_reviewer_recommends: true,
            enable_attributes: true,
            enable_product_name: true,
            enable_review_title: false,
            enable_replies: true,
            enable_images: true,
            enable_ratings: true,
            enable_share: false,
            enable_helpful_vote: true,
            enable_helpful_display: true,
            enable_report: false,
            enable_date: true,
            enable_third_party_source: true,
            enable_duplicate_reviews: undefined,
          },
        },
    
        // Translation settings
        translations: {
          'Verified Customer': 'Verified Customer'
        },
      });
    }
  }

}
let input = document.querySelector('.personalise-gloves-wrapper .checked-label-content input[type=text]');
if(input) {
  counter = document.querySelector('.counter')
  maxLength = input.getAttribute('maxlength')
  counter.innerHTML = `${input.value.length} / ${maxLength}`
  input.addEventListener('keyup', (e) => {
      counter.innerHTML = `${e.target.value.length} / ${maxLength}`
  })

}
const stickyMenu = document.querySelector(".pdp-sticky-menu-wrapper");
let navbarHeight = stickyMenu.getBoundingClientRect().height;
const sections = document.querySelectorAll('[data-section-name]');
const navLi = document.querySelectorAll(".pdp-sticky-menu-wrapper li");

// Show the sticky menu by default
stickyMenu.style.display = '';

window.addEventListener("scroll", () => {
  let current = "";
  let currentSection = null;
  let isActiveSectionInNav = false; // Flag to check if any section is active in navLi

  const stickyMenuTop = stickyMenu.getBoundingClientRect().top;

  sections.forEach((section) => {
    const sectionTop = section.offsetTop;
    const sectionHeight = section.clientHeight;
    let scrollPos = window.scrollY + navbarHeight;
    
    if (scrollPos >= sectionTop && scrollPos < sectionTop + sectionHeight) {
      current = section.getAttribute("id");
      currentSection = section;
    }
  });

  // If scroll is at the top of the page
  if (window.scrollY < sections[0].offsetTop - navbarHeight) {
    current = sections[0].getAttribute("id");
    currentSection = sections[0];
  }

  navLi.forEach((li) => {
    li.querySelector('a').classList.remove("active");
    if (li.querySelector(`a[href="#${current}"]`)) {
      li.querySelector('a').classList.add("active");
      isActiveSectionInNav = true; // Set flag to true if a matching section is found in navLi
    }
  });

  // If no section is active, make the first section active
  if (!currentSection) {
    navLi[0].querySelector('a').classList.add("active");
    isActiveSectionInNav = true; // Also consider the first section as active in navLi
  }
});



document.querySelectorAll(".pdp-sticky-menu-wrapper li a").forEach(anchor => {
  anchor.addEventListener("click", function(event) {
      event.preventDefault();

      const targetId = this.getAttribute("href"); // Get the target section id
      const targetSection = document.querySelector(targetId); 
      if (targetSection) {
          // Scroll to the target section smoothly
          const offsetPosition = targetSection.offsetTop - navbarHeight; 
          window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
          });
      }
  });
});



function gallerycarousel() {
  const carouselItems = document.querySelectorAll(".main-gallery-slider");
  if (carouselItems.length) {

    let mainGalleryCarousek = null;
    function initSwiper() {
      if (window.innerWidth <= 769 && mainGalleryCarousek === null) {
        mainGalleryCarousek = new Swiper(`.main-gallery-slider`, {
          slidesPerView: 1,
          centeredSlides: true,
          loop: true,
          loopedSlides: document.querySelector('.main-gallery-slider').dataset.mediaCount ? document.querySelector('.main-gallery-slider').dataset.mediaCount : 1, //スライドの枚数と同じ値を指定
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
        });
        var thumbnailGallery = new Swiper('.thumbnail-slider-media-gallery', {
          slidesPerView: 'auto',
          spaceBetween: 8,
          centeredSlides: true,
          loop: true,
          slideToClickedSlide: true,
        });


        mainGalleryCarousek.controller.control = thumbnailGallery;
        thumbnailGallery.controller.control = mainGalleryCarousek;
      }
      else if (window.innerWidth > 769 && mainGalleryCarousek !== null) {
        mainGalleryCarousek.destroy();
        mainGalleryCarousek = null;
      }
    }
    initSwiper();

    window.addEventListener("resize", () => {
      initSwiper();
    });
  }
}

gallerycarousel();